import React, { useMemo } from 'react'
import { Switch, Redirect, matchPath, useLocation, useRouteMatch } from 'react-router-dom'
import { PrivateRoute } from '../../Components/Routes'
import Users from './Blocks/Users'
import OneJobPasswords from './Blocks/OneJobPasswords'
import DatabaseManagement from './Blocks/DatabaseManagement'
import UserSettingsTabs from './UserSettingsTabs'
import { UsersSettingsProvider } from './UsersSettingsContext'
import CompanySelector from '../../Components/CompanySelector';
import { useAuth } from '../../Contexts/AuthProvider';
import TemplatesManagement from './Blocks/TemplatesManagement'
import Integrations from './Blocks/Integrations'
import Devices from './Blocks/Devices'
import JobConfiguration from './Blocks/JobConfiguration'
import JobPlannerPage from '../JobPlanner/JobPlannerPage'
import UnitSettings from './Blocks/UnitSettings'
import FleetViewChannelMappings from './Blocks/FleetViewChannelMappings'
import ApiKeys from './Blocks/ApiKeys'
import { useUsersSettings } from './UsersSettingsContext'

const UsersSettingsLayout = ({ path, showCompanySelector }) => {
    const location = useLocation()
    const { tabs, pageHeaderActions, currentUser } = useUsersSettings()

    const canShowFleetViewSettings = useMemo(
        () => currentUser?.allowUiFleetView?.() && (currentUser?.isSuperuser?.() || currentUser?.isMaster?.()),
        [currentUser],
    )

    const activeSettingsTitle = useMemo(() => {
        const matchedTab = tabs.find(({ path: tabPath = '', exact }) => {
            const tabRoute = tabPath ? `${path}/${tabPath}` : path
            return Boolean(matchPath(location.pathname, { path: tabRoute, exact: exact !== false }))
        })

        return matchedTab?.title || matchedTab?.label || tabs?.[0]?.title || tabs?.[0]?.label || ''
    }, [location.pathname, path, tabs])

    return (
        <div className="settingsPageLayout">
            <aside className="settingsPageSidebar">
                {showCompanySelector && (
                    <div className="asideNavHolder settingsPageCompanySelector">
                        <div className="changeCompanyHeader">
                            <CompanySelector />
                        </div>
                    </div>
                )}
                <div className="asideNavHolder secondary">
                    <UserSettingsTabs path={path}/>
                </div>
            </aside>
            <div className="settingsPageContent">
                <div className="settingsPageTitleRow">
                    <div className="settingsPageTitle">{activeSettingsTitle}</div>
                    {pageHeaderActions ? (
                        <div className="settingsPageTitleActions">{pageHeaderActions}</div>
                    ) : null}
                </div>
                <div className="pageBlock">
                    <Switch>
                        <Redirect from={path} to={`${path}/job-planner`} exact/>
                        <PrivateRoute path={`${path}/users`} component={Users} exact/>
                        <PrivateRoute path={`${path}/one-job-password`} component={OneJobPasswords} exact/>
                        <PrivateRoute path={`${path}/db-management`} component={DatabaseManagement} exact/>
                        <PrivateRoute path={`${path}/integrations`} component={Integrations} exact/>
                        <PrivateRoute path={`${path}/templates-management`} component={TemplatesManagement} exact/>
                        <PrivateRoute path={`${path}/devices`} component={Devices} exact/>
                        <PrivateRoute path={`${path}/job-configuration`} component={JobConfiguration} exact/>
                        <PrivateRoute path={`${path}/job-planner`} component={JobPlannerPage} exact/>
                        <PrivateRoute path={`${path}/unit-settings`} component={UnitSettings} exact/>
                        {canShowFleetViewSettings ? (
                            <PrivateRoute path={`${path}/fleet-view-settings`} component={FleetViewChannelMappings} exact/>
                        ) : null}
                        <PrivateRoute path={`${path}/api-keys`} component={ApiKeys} exact/>
                    </Switch>
                </div>
            </div>
        </div>
    )
}

const UsersSettingsPage = () => {

    const {path} = useRouteMatch()
    const {currentUser} = useAuth();
    const showCompanySelector = useMemo(() => currentUser.isMaster(), [currentUser])

    return (
        <main>
            <UsersSettingsProvider>
                <div className="mainContainer settingsMainContainer">
                    <UsersSettingsLayout path={path} showCompanySelector={showCompanySelector} />
                </div>
            </UsersSettingsProvider>
        </main>
    )
}

export default UsersSettingsPage
